import _ from 'lodash';
import daDK from 'antd/lib/locale/da_DK';
import 'moment/locale/da';

import { Translations } from './@generated/Translations';
import dk from './@generated/dk.json';

const daDKCustomized = {
    ...daDK,
    DatePicker: {
        ...daDK.DatePicker,
        lang: {
            ...daDK.DatePicker.lang,
            placeholder: dk.components.datePicker.placeholder,
            dateFormat: dk.components.datePicker.dateFormat,
        },
    },
};

const availableLanguages: Record<string, any> = {
    dk: {
        translations: dk,
        antdLocale: daDKCustomized,
    },
};

const initialLanguage: any = availableLanguages.dk;

let i18n: Translations = initialLanguage.translations;
let i18nAntdLocale: typeof daDK = initialLanguage.antdLocale;

const setLanguage = (languageCode: string): void => {
    if (availableLanguages.hasOwnProperty(languageCode)) {
        i18n = availableLanguages[languageCode].translations;
        i18nAntdLocale = availableLanguages[languageCode].antdLocale;
    } else {
        throw new Error(`Invalid language code ${languageCode}`);
    }
};

const getByName = (errorCode: string): string => _.get(i18n, errorCode);

export { i18n, i18nAntdLocale, setLanguage, getByName };
